import buildNumber from 'buildNumber';

export default `${process.env.REACT_APP_VERSION}.${buildNumber}`;
